export default "__VITE_ASSET__Dm2fx2mr__"